import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import { Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Image from "../../../Assets/assetHelper";
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';
import KenColors from '../../../Helpers/Themes/kenColors';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  hideSideBar: boolean
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick, hideSideBar }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const [openPeople, setOpenPeople] = useState(false);

  const handlePeopleClick = () => {
    setOpenPeople(!openPeople);
  };

  const sideNavContents = [
    {
      icon: (isActive: boolean) => (
        <HomeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => (
        <AnalyticsOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'My portfolio',
      link: routes.myPortfolio,
      name: 'portfolio',
    },
    {
      icon: (isActive: boolean) => (
        <img src={Image.Icons.editFileIcon} alt="editFileIcon" className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Startups',
      link: routes.startups,
      name: 'startups',
    },
    {
      icon: (isActive: boolean) => (
        <img src={Image.Icons.leafIcon} alt="leafIcon" className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Get Involved',
      link: routes.getinvolved,
      name: 'involved',
    },
    {
      icon: (isActive: boolean) => (
        <AccountCircleOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'People',
      link: '#',
      name: 'people',
      nested: true,
      nestedItems: [
        {
          icon: (isActive: boolean) => (
            <GroupsOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          ),
          name: 'OurTeam',
          label: 'Our Team',
          link: routes.ourTeam,
        },
        {
          icon: (isActive: boolean) => (
            <CurrencyRupeeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
          ),
          name: 'OurInvestors',
          label: 'Our Investors',
          link: routes.ourInvestors,
        },
      ],
    },
    {
      icon: (isActive: boolean) => (
        <AutoAwesomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: (isActive: boolean) => (
        <LightbulbOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'COE',
      link: routes.coe,
      name: 'coe',
    },
    {
      icon: (isActive: boolean) => (
        <ContactSupportOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Support',
      link: routes.support,
      name: 'support',
    },
    {
      icon: (isActive: boolean) => (
        <img src={Image.Icons.websplitIcon} alt="websplitIcon" className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'GIC Portal',
      link: routes.juryPortal,
      name: 'jury',
    },
  ];

  const isActive = (link: string) => pathname.startsWith(link);
  const isAnyNestedItemActive = (nestedItems: any[]) => {
    return nestedItems.some(nestedItem => isActive(nestedItem.link));
  };

  return (
    <>
      {sideNavContents.map((items, index) => {
        if (items.nested) {
          const anyNestedItemActive = isAnyNestedItemActive(items.nestedItems);
          return (
            <div key={index}>
              <ListItemButton
                onClick={handlePeopleClick}
                sx={{ marginTop: index === 0 ? { xs: "10px", sm: "15px", md: "25px", lg: '35px' } : '12px' }}
                className={`${classes.listItemButton} ${anyNestedItemActive && classes.nestedlistItemButtonActive}`}
              >
                <ListItemIcon sx={{ minWidth: '40px' }}>{items.icon(items.nestedItems.some(nestedItem => isActive(nestedItem.link)))}</ListItemIcon>
                {!hideSideBar && (
                  <>
                    <ListItemText
                      className={`${classes.listItemText} ${items.nestedItems.some(nestedItem => isActive(nestedItem.link)) && classes.listItemTextActive}`}
                      sx={{
                        display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                      }}
                    >
                      {items.label}
                    </ListItemText>
                    {openPeople ? <ExpandLess sx={{ color: KenColors.kenWhite }} /> : <ExpandMore sx={{ color: KenColors.kenWhite }} />}
                  </>
                )}
              </ListItemButton>
              <Collapse in={openPeople} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {items.nestedItems.map((nestedItem, nestedIndex) => (
                    <ListItemButton
                      key={nestedIndex}
                      onClick={() => handleListClick(nestedItem.link, nestedIndex)}
                      className={`${classes.listItemButton} ${isActive(nestedItem.link) && classes.listItemButtonActive}`}
                    >
                      <Box sx={{ ml: hideSideBar ? 0 : 2, display: "flex", alignItems: "center" }}>
                        <ListItemIcon sx={{ minWidth: '40px' }}>{nestedItem.icon(isActive(nestedItem.link))}</ListItemIcon>
                        {!hideSideBar && <ListItemText primary={nestedItem.label} className={`${classes.listItemText} ${isActive(nestedItem.link) && classes.listItemTextActive}`}
                          sx={{
                            display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                          }} />}
                      </Box>
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </div>
          );
        } else {
          return (
            <ListItemButton
              key={index}
              onClick={() => {
                handleListClick(items.link, index);
              }}
              sx={{ marginTop: index === 0 ? { xs: "10px", sm: "15px", md: "25px", lg: '35px' } : '12px' }}
              className={`${classes.listItemButton} ${isActive(items.link) && classes.listItemButtonActive}`}
            >
              <ListItemIcon sx={{ minWidth: '40px' }}>{items.icon(isActive(items.link))}</ListItemIcon>
              {!hideSideBar && (
                <ListItemText
                  className={`${classes.listItemText} ${isActive(items.link) && classes.listItemTextActive}`}
                  sx={{
                    display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                  }}
                >
                  {items.label}
                </ListItemText>
              )}
            </ListItemButton>
          );
        }
      })}
    </>
  );

};

export default SideNavTabs;
